'use strict';
const angular = require('angular');
const {isObject, lowercase} = angular;
const includes = require('lodash/includes');

//DomainFilter
export const filterDomainAsStringImport = [
  filterDomainAsString];

function filterDomainAsString() {
  return function (list, query) {
    if (!query || typeof query !== 'string') return list;

    query = lowercase(query);

    var item, itemKey, result = {};

    for (itemKey in list) {
      if (list.hasOwnProperty(itemKey)) {
        item = list[itemKey];

        if (item && isObject(item)) {
          if (item && includes(item.toString().toLowerCase(), query)) {
            result[itemKey] = list[itemKey];
          }
        }
      }
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/filterDomainAsString.js